import script from "./videoGuidePop.vue?vue&type=script&setup=true&name=videoGuidePop&lang=js"
export * from "./videoGuidePop.vue?vue&type=script&setup=true&name=videoGuidePop&lang=js"

const __exports__ = script;

export default __exports__